import { render, staticRenderFns } from "./empty.vue?vue&type=template&id=f1fadc0a"
import script from "./empty.vue?vue&type=script&lang=ts"
export * from "./empty.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports